<template>
  <Container class="container--main">
    <h1 class="title">Registro de usuario</h1>
    <div class="card">
      <b>Recuerda que: </b>Los datos y/ o información del presente servicio se basan en la Resolución Ministerial Nº 355-2018-VIVIENDA
      y en la Ley Nº 27806, Ley de Transparencia y Acceso a la Información Pública.
    </div>
    <form action="form" class="form" @submit.prevent="registerUser">

      <label class="form-label" for="nombre">Nombres<span class="camp_required">*</span>:</label>
      <input
        v-model="nombre"
        class="form-input"
        type="text"
        id="nombre"
        placeholder="Ingrese sus nombres"
        required
      >

      <label class="form-label" for="apellido">Apellidos<span class="camp_required">*</span>:</label>
      <input
        v-model="apellido"
        class="form-input"
        type="text"
        id="apellido"
        placeholder="Ingrese sus apellidos"
        required
      >

        <label class="form-label" for="email">Correo electrónico<span class="camp_required">*</span>:</label>
        <input
          v-model="email"
          class="form-input"
          type="email"
          id="email"
          required
          placeholder="Ingrese su correo electrónico"
        >

        <label class="form-label" for="entity">Entidad:</label>
        <input
          v-model="entity"
          class="form-input"
          type="text"
          id="entity"
          placeholder="Ingrese la entidad/empresa a la que pertenece"
        >

        <label class="form-label" for="password">Contraseña<span class="camp_required">*</span>:</label>
        <input
          v-model="password"
          class="form-input"
          type="password"
          id="password"
          required
          placeholder="Ingrese una contraseña"
        >
        <ul>
          <li>La contraseña debe ser de longitud mayor o igual 8 caracteres.</li>
          <li>Debe contener al menos una mayúscula, una minúscula y un carácter especial (@#$!%*^?&)</li>
        </ul>
          <br>
          <p class="camp_required">(*) Estos son campos requeridos</p>
          <br>
        <label class="">
            <input
              type="checkbox"
              v-model="isChecked"
              >
            Acepto los <a href="https://cdn.www.gob.pe/uploads/document/file/4131509/Aprobar%20Pol%C3%ADtica%20de%20Protecci%C3%B3n%20de%20Datos%20Personales%20en%20el%20IGP.pdf?v=1676574799" target="_blank">términos y condiciones</a> para el tratamiento de mis datos.   
          </label>

        <Button
          class="btn__submit"
          tag="button"
          type="submit"
          theme="primary"
          :disabled="!isChecked"
          >
            Registrarse
        </Button>
      

        <ul class="errores_msg" v-if="errorList">
          <li v-for="error in errorList" :key="error">{{ error.msg }}.</li>
        </ul>
          
    </form>
      <hr>
      <p style="text-align: center;">¿Ya tienes una cuenta registrada, <router-link :to="'/inicio-sesion'"> inicia sesión </router-link>?</p>

      
  </Container>
</template>

<script>
import axios from "axios";
import Button from "@/components/ui/atoms/Button.vue";
import Container from "@/components/ui/objects/Container";

export default {
  components: {
    Button,
    Container
  },
  data() {
    return {
      email: '',
      entity: '',
      password: '',
      nombre: '',
      apellido: '',
      errorList: null,
      isChecked: false
    };
  },
  methods: {
    registerUser() {
      axios.post(`${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/create`, {
        email: this.email,
        entidad: this.entity,
        password: this.password,
        apellido: this.apellido,
        nombre: this.nombre,
        confirma_condiciones: this.isChecked,
      })
      .then(response => {
        let token = response.data.token;
        if(token){
          localStorage.setItem("token", token);
          this.$router.push({ path: '/edificaciones-instrumentadas'});
        }
      })
      .catch(error => {
        this.errorList = error.response.data.errors;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.register {
  padding: 2rem;
  width: 60%;
  margin: auto;
}
.title {
  text-align: center;
  color: variables.$primary-color;
}
.form {
  margin: 1rem auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  min-width: 350px;
  max-width: 100%;
  border-radius: 5px;
}
.form-label {
  margin-top: 2rem;
  color: variables.$primary-color;
  margin-bottom: 0.5rem;
  &:first-of-type {
    margin-top: 0rem;
  }
}
.form-input {
  padding: 10px 15px;
  background: none;
  background-image: none;
  border: 1px solid variables.$primary-color;
  color: rgb(95, 95, 95);
  &:focus {
    outline: 0;
    border: 2px solid variables.$primary-color;
  }
}

.errores_msg li{
  color: red;
}
.camp_required{
  color: rgb(180, 12, 12);
}

.btn__submit{
  margin-top: 2rem;
}

.card{
  padding: 1rem;
  background: #e1fcdc;
  border-radius: 10px;
}

.card b{
  color: #385e31;
}
</style>